import {useQuery} from '@tanstack/react-query';
import * as CodeRepositoriesService from '../services/CodeRepositoriesService';

export const codeRepositoriesKeys = {
    all: ['codeRepositories'] as const,
    lists: () => [...codeRepositoriesKeys.all, 'list'] as const,
    list: (filters: object) => [...codeRepositoriesKeys.lists(), filters] as const,
};

export const useCodeRepositories = (filters: object = {}) => {
    const {data, isLoading: loading} = useQuery({
        queryKey: codeRepositoriesKeys.list(filters),
        queryFn: () => CodeRepositoriesService.fetchRecords({filter: filters}),
    });

    return {
        items: data?.items ?? [],
        loading,
    };
};
